import Link from 'next/link';

interface PreviewBannerProps {
    preview?: boolean;
}

export const PreviewBanner = ({ preview = false }: PreviewBannerProps) => {
    return preview ? (
        <div className="fixed bottom-0 z-[100] w-full bg-indigo-600">
            <div className="max-w-7xl mx-auto py-3 px-3 sm:px-6 lg:px-8">
                <div className="pr-16 sm:text-center sm:px-16">
                    <p className="font-medium text-white">
                        <span>Preview mode is on,</span>
                        <span className="block sm:ml-2 sm:inline-block">
                            <Link href="/api/exit-preview" className="underline hover:text-cyan transition-colors">
                                turn off
                            </Link>
                        </span>
                    </p>
                </div>
            </div>
        </div>
    ) : null;
};
